var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.764 389.905-113.657 113.656c-11.252 11.252-29.495 11.252-40.746 0l-195.805-195.805c-3.126-3.126-4.944-7.326-5.084-11.744l-3.686-116.109c-.152-4.801 1.688-9.451 5.084-12.848l38.916-38.916c3.396-3.397 8.047-5.237 12.848-5.084l73.363 56.581c4.419.14 37.012-26.435 40.138-23.309l188.629 192.832c11.252 11.251 11.252 29.494 0 40.746z",
    fill: "#c0d4df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.986 136.324 191.304 191.302c11.252 11.252 11.252 29.494 0 40.746l-25.038 25.038c11.252-11.252 11.252-29.494 0-40.746l-188.626-192.832c-3.122-3.122-57.252 44.98-61.665 44.844l-73.362-56.584c-4.801-.151-9.451 1.686-12.845 5.081l25.03-25.031c3.402-3.401 8.052-5.238 12.853-5.088l73.362 56.584c4.413.137 55.866-46.435 58.987-43.314z",
    fill: "#b2c6d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.391 350.574-110.086 110.086c-4.527 4.527-11.867 4.527-16.395 0l-16.553-16.553c-4.527-4.527-4.527-11.867 0-16.395l110.086-110.086c4.527-4.527 11.867-4.527 16.395 0l16.553 16.553c4.527 4.527 4.527 11.868 0 16.395z",
    fill: "#9fafe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.92 153.764-79.495-84.708c-3.287-3.503-7.876-5.489-12.68-5.489h-24.59c-4.803 0-9.393 1.987-12.68 5.489l-79.495 84.708c-3.025 3.223-4.709 7.479-4.709 11.899v276.91c0 15.912 12.899 28.812 28.812 28.812h160.734c15.912 0 28.812-12.9 28.812-28.812v-276.91c0-4.42-1.684-8.675-4.709-11.899zm-89.247-12.416c-11.548 0-20.909-9.361-20.909-20.91 0-11.548 9.361-20.909 20.909-20.909s20.909 9.362 20.909 20.909c0 11.549-9.361 20.91-20.909 20.91z",
    fill: "#f3f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.366 153.762-79.494-84.711c-3.288-3.501-7.875-5.48-12.676-5.48h-34.211c4.8 0 9.388 1.979 12.676 5.48l79.494 84.711c3.024 3.227 4.709 7.479 4.709 11.904v276.906c0 15.913-12.899 28.812-28.812 28.812h34.211c15.913 0 28.812-12.899 28.812-28.812v-276.905c0-4.425-1.685-8.677-4.709-11.905z",
    fill: "#e6eef2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.516 428.461h-155.686c-6.403 0-11.593-5.19-11.593-11.593v-23.41c0-6.402 5.19-11.593 11.593-11.593h155.685c6.402 0 11.593 5.19 11.593 11.593v23.41c0 6.403-5.19 11.593-11.592 11.593z",
    fill: "#9fafe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.253 250.058h-74.494c-4.204 0-7.611-3.407-7.611-7.611s3.408-7.611 7.611-7.611h74.494c4.204 0 7.612 3.407 7.612 7.611s-3.408 7.611-7.612 7.611z",
    fill: "#fe99a0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#879eaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m262.253 296.531h-165.16c-4.204 0-7.611-3.407-7.611-7.611s3.408-7.612 7.611-7.612h165.16c4.204 0 7.612 3.407 7.612 7.612 0 4.204-3.408 7.611-7.612 7.611z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.673 343.004h-82.58c-4.204 0-7.611-3.407-7.611-7.612s3.408-7.611 7.611-7.611h82.58c4.204 0 7.611 3.407 7.611 7.611s-3.407 7.612-7.611 7.612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.28 67.499c0 18.43-7.074 35.946-19.293 48.572l-10.433-11.123c9.195-9.763 14.502-23.24 14.502-37.448 0-28.822-21.515-52.276-47.963-52.276s-47.962 23.453-47.962 52.276c0 10.362 2.771 20.368 8.017 28.944.69 1.116 1.411 2.202 2.172 3.258-.873-.112-1.756-.172-2.649-.172-4.821 0-9.256 1.634-12.787 4.374-6.526-10.859-9.976-23.433-9.976-36.403.001-37.218 28.346-67.501 63.186-67.501 34.841 0 63.186 30.283 63.186 67.499z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m262.253 203.586h-74.494c-4.204 0-7.611-3.407-7.611-7.611s3.408-7.611 7.611-7.611h74.494c4.204 0 7.612 3.407 7.612 7.611 0 4.203-3.408 7.611-7.612 7.611z",
    fill: "#fe99a0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.793,
    cy: 220.675,
    fill: "#9fafe9",
    r: 24.701
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.5c8d4eb88dada56b1fff50ec79b79299.svg";
export { ForwardRef as ReactComponent };